import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../constants/colors';
import { fontSize } from '../../../../../constants/text';

const StyledContainer = styled.div.withConfig({ componentId: 'sc-56q1w6-0' })`
  display: flex;
  align-items: center;
  padding-top: 32px;
  padding-bottom: 16px;
  font-size: ${fontSize.mediumSmall};
  line-height: 20px;
  color: ${colors.gray500};
`;

const StyledDivider = styled.div.withConfig({ componentId: 'sc-56q1w6-1' })`
  flex-grow: 1;
  border-top: 1px solid ${colors.gray300};
`;

const StyledTitleDiv = styled.div.withConfig({ componentId: 'sc-56q1w6-2' })`
  padding: 0 16px;
`;

const StyledTitle = (props: { title: string }) => {
  return (
    <StyledContainer>
      <StyledDivider />
      <StyledTitleDiv>{props.title}</StyledTitleDiv>
      <StyledDivider />
    </StyledContainer>
  );
};

export default StyledTitle;
